export enum PackagesQuery {
  OWNED = "owned",
  ASSETS = "assets",
  JOBS = "jobs",
  JOB_DEFS = "jobDefinitions",
  JOBS_DETAILS = "jobsDetials",
}

export enum PackagesApiPath {
  OWNED = "/assets/owned",
  ASSETS = "/assets",
  VERSIONS = "/versions",
  JOBS = "/jobs",
  DEFINITIONS = "/definitions",
  BY_ASSET = "/by_asset",
  RESULTS = "/results",
}
